import React, { Component } from 'react';  
import { Picker, List, Toast } from 'antd-mobile/lib';
import { connect } from 'react-redux';
import { 
	getBankList,
	bankList,
	bankType,
	smrzUpdatePhoneNo,
	smrzAgreeItemFlag,
	clearSmrzCheckCard
} from '../../action/investmentAction.js';
import { protocolCode } from '../../BankCode'
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import { getBankProtocollnfoList } from '../../action/myCardsAction.js';
import { getTempInfo} from '../../common.js';

class CertificationSetPhone extends Component {
	state = {
		phoneNumber: this.props.smrzUpdatePhoneNo ? this.props.smrzUpdatePhoneNo : this.props.location.state.phoneNo,
		agreeIcon: this.props.smrzAgreeItemFlag,
		enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
		verificationCodeBool: false,
		iSstateBool: false,
		agreementValue: ''
	}

	componentWillMount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
		document.getElementsByTagName('title')[0].innerHTML = "实名认证";
	}

	async componentDidMount(){
		this.props.dispatch(getBankList());
		let params = {
		  token: await getTempInfo("shortToken"),
		  bankAccountNo: this.props.location.state.bankAccountShowNo
		}
		this.props.dispatch(getBankProtocollnfoList(params, (value)=>{
			this.setState({agreementValue: value})
		},(message)=>{Toast.info( message, 2 );}))
	}

	sure = () => {
		let regPhone = /^1[0123456789]\d{9}$/;
		let { bankList, bankType, dispatch } = this.props;
		let { savePicFun, actualControllerCity, actualBeneficiaryCity, phoneNo, name, certNo, bankAccountShowNo, address, careerCode, cityCode, provinceCode, actualBeneficiary, actualController, actualBeneficiaryCertType, actualBeneficiaryCertNo, actualControllerCertType, actualControllerCertNo, officialsOrRelatives,annualIncomeV2,annualIncome,actualControllerBirthday,actualControllerValidTerm,actualControllerValidEver,actualControllerSex,actualControllerMobileNo,actualControllerProvince,actualControllerProfession,actualControllerAddress,actualControllerPostcode,actualControllerEmail,actualBeneficiaryValidTerm,actualBeneficiaryValidEver,actualBeneficiarySex,actualBeneficiaryBirthday,actualBeneficiaryMobileNo,actualBeneficiaryProvince,actualBeneficiaryAddress,actualBeneficiaryPostcode,actualBeneficiaryProfession,actualBeneficiaryEmail,conversationId,certLifeTime,certValidEver,certValidTerm } = this.props.location.state;
		if(this.state.bank == "") {
			Toast.info( "请选择银行卡类型", 2);
			return ;
		}
		if(!(regPhone.test(this.state.phoneNumber))){ 
			Toast.info( "手机号有误，请重新输入", 2);
	        return ; 
	    }
	    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    	let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
	    for(let i = 0; i < bankList.content.length; i++) {
			if(bankList.content[i].bankCode == bankType.content.bankCode) {
				hashHistory.push({
					pathname: "/certificationCheckPhone",
					state: {
						mobileNo: phoneNo,
						name: name,
						certNo: certNo,
						certType: 0,
						bankAccountShowNo: bankAccountShowNo,
						trustChannelId: bankList.content[i].paymentChannelId,
						bankCode: bankList.content[i].bankCode,
						bankAccountName: bankList.content[i].paymentChannelName,
						route: this.props.route ? this.props.route : null,
						callback: this.props.callback ? this.props.callback : null,
						address: address,
						careerCode: careerCode,
						cityCode: cityCode,
						provinceCode: provinceCode,
						actualBeneficiary: actualBeneficiary,
						actualController: actualController,
						actualBeneficiaryCertType: actualBeneficiaryCertType,
						actualBeneficiaryCertNo: actualBeneficiaryCertNo,
						actualControllerCertType: actualControllerCertType,
						actualControllerCertNo: actualControllerCertNo,
						officialsOrRelatives: officialsOrRelatives, 
						callback: callback,
						route: route,
						annualIncomeV2:annualIncomeV2,
						annualIncome:annualIncome,
						actualControllerBirthday: actualControllerBirthday,
						actualControllerValidTerm: actualControllerValidTerm,
						actualControllerValidEver: actualControllerValidEver,
						actualControllerSex: actualControllerSex,
						actualControllerMobileNo: actualControllerMobileNo,
						actualControllerProvince: actualControllerProvince,
						actualControllerProfession: actualControllerProfession,
						actualControllerAddress: actualControllerAddress,
						actualControllerPostcode: actualControllerPostcode,
						actualControllerEmail: actualControllerEmail,
						actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
						actualBeneficiaryValidEver: actualBeneficiaryValidEver,
						actualBeneficiarySex: actualBeneficiarySex,
						actualBeneficiaryBirthday: actualBeneficiaryBirthday,
						actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
						actualBeneficiaryProvince: actualBeneficiaryProvince,
						actualBeneficiaryAddress: actualBeneficiaryAddress,
						actualBeneficiaryPostcode: actualBeneficiaryPostcode,
						actualBeneficiaryProfession: actualBeneficiaryProfession,
						actualBeneficiaryEmail: actualBeneficiaryEmail,
						actualBeneficiaryCity: actualBeneficiaryCity,
						actualControllerCity: actualControllerCity,
						savePicFun: savePicFun,
						conversationId: conversationId,
						certLifeTime: certLifeTime,
						certValidEver: certValidEver,
						certValidTerm: certValidTerm,
						bankProtocolVersion: this.state.agreementValue.bankProtocolVersion,
          				upProtocolVersion: this.state.agreementValue.upProtocolVersion
					},
					query: {enterType:this.state.enterType,
						activityId:this.props.location.query.activityId}
				});
				dispatch(clearSmrzCheckCard());
				this.setState({agreeIcon: false})
			}
		}
	}

	goCertification = () => {
		this.setState({verificationCodeBool: true})
	}

	ProtocolPaper(name,value){
	    let code=protocolCode[name];
		if(code){
			hashHistory.push({
				pathname:'/WebView',
				state:{name:name,code:code},
				query: {code:code}
			})
		}else{
			let newName = name.substring(1,name.length-1)
			hashHistory.push({
			  pathname:'/WebView',
			  state:{name:newName,webViewHtml:(value=='bankProtocolName'?this.state.agreementValue.bankProtocolUrl:this.state.agreementValue.upProtocolUrl)},
			  query: {code:code}
			})
		}
	}

	changePhoneNumber = (event) => {
		let { dispatch } = this.props;
		this.setState({
			phoneNumber :event.target.value
		})
		dispatch(smrzUpdatePhoneNo(event.target.value));
	}

	changeBank = (value) => {
		this.setState({iSstateBool: true})
		let { dispatch, bankList } = this.props;
		if(value[0]){
			for(let i = 0; i < bankList.content.length; i++) {
				if(value[0] == bankList.content[i].bankCode) {
					dispatch(bankType({content:{
						cardName: bankList.content[i].paymentChannelName,
						bankCode: value[0]
					}}));
				}
			}
		}else{
			dispatch(bankType({content:{
				cardName: bankList.content[0].paymentChannelName,
				bankCode: "002"
			}}));
		}
	}

	changeAgree = () => {
		let { dispatch } = this.props;
		this.setState({
			agreeIcon: this.state.agreeIcon ? false : true
		})
		let flag =  this.state.agreeIcon ? false : true
		dispatch(smrzAgreeItemFlag(flag))
	}

	goBack = () => {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
		hashHistory.goBack();
	}

	componentWillUnmount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
	}

	render() {
		const img_arr = [require('../../img/square.png'),require('../../img/protocol_selected.png')];
		let { agreeIcon, phoneNumber, bank } = this.state;
		let { bankList, bankType } = this.props;
		console.log(bankType,bankList)
		let bankArr = [];
		if(bankList != null) {
			for(let i = 0; i < bankList.content.length; i++) {
				bankArr.push({
					label: bankList.content[i].paymentChannelName,
					value: bankList.content[i].bankCode
				});
			}
		}
		return (
			<div className="mainBox"> 
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
		            </div>
		            <div>
		              <span>实名认证</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
		        <div className="boxContent">
			        <div>
						<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
							<div style={{fontSize: "13px", color: "#5b6370"}}>需要对您在该银行预留的手机号进行校验</div>
						</div>
						<div className="pickerBox" style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={bankType != null ? [bankType.content.bankCode] : ""} extra={bankType != null ? bankType.content.cardName : ""} title="银行卡列表" data={bankArr} onChange={this.changeBank} cols={1} className="forss">
			                  <List.Item arrow="horizontal">卡类型</List.Item>
			                </Picker>
						</div>
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								手机号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={this.state.phoneNumber}
							onChange={this.changePhoneNumber}
							placeholder="请输入银行预留手机号"
							/>
						</div>
					</div>
					{
						phoneNumber != "" && bankType && bankType.content.bankCode!=null && this.state.agreementValue?
						<div style={{
							display: "-webkit-flex",
							marginTop: 15,
							height: 40,
							backgroundColor: "#fa063a",
							WebkitJustifyContent: "center",
							WebkitAlignItems: "center",
							borderRadius: 30,
							marginLeft: 13,
							marginRight: 13,
							marginBottom: 15
						}}
						key={0}
						onClick={this.goCertification}
						>
							<div style={{color: "#fff", fontSize: 15}}>下一步</div>
						</div> :
						<div style={{
							display: "-webkit-flex",
							marginTop: 15,
							height: 40,
							backgroundColor: "#afb0b2",
							WebkitJustifyContent: "center",
							WebkitAlignItems: "center",
							borderRadius: 30,
							marginLeft: 13,
							marginRight: 13,
							marginBottom: 15
						}}
						key={0}
						>
							<div style={{color: "#fff", fontSize: 15}}>下一步</div>
						</div>
					}
					<div className='addCard-tipBox'>
              <p>温馨提示 :</p>
              <p>如果您的银行卡是由交通银行、浦发银行、平安银行或邮储银行发行的。您需要先通过电脑访问银联官网开通该卡的银联在线支付，网址：https://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay。开通成功后，再通过APP绑定该类银行卡即可。为此造成的不便，敬请谅解。</p>
            </div>
				</div>
				{
					this.state.verificationCodeBool ?
					<div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
					<div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
						<div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
						<p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
						</div>
						<div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20, fontSize:'0.28rem'}}>
							<img src={img_arr[agreeIcon?1:0]} className='imgBtn' style={{marginTop:'-0.35rem'}} onClick={()=>this.changeAgree()}/>
							<p style={{lineHeight:'0.35rem'}}>我已阅读并同意
								<span style={{color:"#fa063a"}} onClick={()=>this.ProtocolPaper('上海华夏财富投资管理有限公司快易付业务协议')}>《上海华夏财富投资管理有限公司快易付业务协议》</span>、
								<span style={{color:"#fa063a"}} onClick={()=>this.ProtocolPaper(this.state.agreementValue.bankProtocolName,'bankProtocolName')}>{this.state.agreementValue.bankProtocolName}</span>、
                      <span style={{color:"#fa063a"}} onClick={()=>this.ProtocolPaper(this.state.agreementValue.upProtocolName,'upProtocolName')}>{this.state.agreementValue.upProtocolName}</span>
							</p>
						</div>
						<div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
						<div onClick={()=>{this.setState({verificationCodeBool: false,agreeIcon: false})}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
							<p style={{fontSize: 14, color: "#F92C3D"}}>取消</p>
						</div>
						{
						this.state.agreeIcon?
						<div onClick={this.sure} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
							<p style={{fontSize: 14, color: "#fff"}}>同意并继续</p>
						</div>
						:
						<div onClick={()=>{Toast.info( "请先阅读并确认协议",2 );}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#ccc", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
							<p style={{fontSize: 14, color: "#fff"}}>同意并继续</p>
						</div>
						}
						</div>
					</div>
					</div>
					:
					null
				}
			</div>
		)
	}
}

function mapStateToProps(state,ownProps) {
  return {
    bankList: state.bankList,
    bankType: state.bankType,
    smrzUpdatePhoneNo: state.smrzUpdatePhoneNo,
    smrzAgreeItemFlag: state.smrzAgreeItemFlag
  }
}

export default connect(mapStateToProps)(CertificationSetPhone);


// WEBPACK FOOTER //
// ./src/components/recommend/CertificationSetPhone.js